// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1yl5M","label":"Category_label__1xrM4","content":"Category_content__2cp8h","header":"Category_header__Vn9Mt","location":"Category_location__2rQVR"};